/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import type { MapSearchResultLocation } from './map.types';

/** Fallback map center (geographic center of the contiguous US) when no location is set. */
export const defaultSearchLocation: MapSearchResultLocation = {
    latitude: process.env.DEFAULT_SEARCH_LOCATION?.lat ?? 38.0,
    longitude: process.env.DEFAULT_SEARCH_LOCATION?.lng ?? -97.0,
};

/** Upper bound on inventory results requested from `/search/geo`. */
export const maximumMapSearchResults = 400;
